import '@madup-inc/mad-design/dist/index.css';
import * as React from 'react';
export default {
  React
};